module.exports = __webpack_public_path__ + "static/media/acompanamientos_checked.b355165d.svg";